import Divider from "@components/general/Divider";
import { renderLoading } from "@pages/BoardingPass";
import { FC } from "react";
import { ITopicItem } from "./AgendaTopic";

interface ILargeViewTopicsItemProps extends ITopicItem { }

const LargeViewTopicsItem: FC<ILargeViewTopicsItemProps> = ({
    displayText,
    durationTime,
    presenter,
    rangeOfTopic,
    loading,
    first,
    last
}) => {
    return <>
        <div className={`content row-item flex row${first ? " first": ""}${last ? " last": ""}`}>
            <div className='col-1-6 cell'>{
                loading ?
                    renderLoading().longStringBox :
                    rangeOfTopic
            }
            </div>
            <div className='col-1-7 cell'>{loading ? renderLoading().longStringBox : durationTime}</div>
            <div className='col-1-5 flex-grow cell'>{loading ? renderLoading().longStringBox : displayText}</div>
            <div className='col-1-5 cell'>{loading ? renderLoading().longStringBox : presenter}</div>
        </div>
        <Divider
            mode="perforation"
            orientation="horizontal"
        />
    </>;
};

export default LargeViewTopicsItem;